module.exports = __webpack_public_path__ + "static/media/ic_pagination_next.0becc5a4.svg";